import Vue from 'vue';
import _ from 'lodash';
import path from 'path';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import Prism from 'prismjs';
import { uploader } from '@/mixins/aws/uploader/s3';
import uploadProgress from '@/mixins/aws/uploader';
import Editor from '@tinymce/tinymce-vue';
import dropsLoader from '@/mixins/components/drops-loader';
import { guid } from '@/mixins/guid';
import { cognitoMixins } from '@storm/mixins/cognito';
import loadData from '@storm/mixins/load-data';
import { DEFAULT_PROFILE_PIC } from '@/constants';
import fontColors from '@editor/droplets/_bubble-options/components/inline-text/font-colors.json';

export default Vue.component('storm-tickets-view', {
  template: require('./template.html'),
  name: 'storm-tickets-view',
  mixins: [cognitoMixins, guid, uploader, loadData],
  computed: {
    ...mapGetters([
      'stormUsers',
      'stormUser',
      'mappedStormUsers',
      'ticketUsers',
      'stormSession',
      'cache',
    ]),
    colors() {
      const list = [];
      _.forEach(fontColors, (hex) => {
        list.push(hex, hex);
      });
      return list;
    },
    filteredUsers() {
      // map storm users, make assign to me top
      const cleanList = _.map(this.stormUsers, user => ({
        _id: user.Username,
        email: this.getAttr(user.Attributes, 'email'),
        name: this.getAttr(user.Attributes, 'name'),
        picture: this.getAttr(user.Attributes, 'custom:pic'),
      }));
      const search = new RegExp(this.searchInput, 'gi');
      const current = _.find(cleanList, user => user._id === this.stormUser.sub);
      const filtered = _.filter(cleanList, item => (
        item.name.match(search) || item.email.match(search)
      ) && item._id !== this.stormUser.sub);
      return [current].concat(filtered);
    },
  },
  components: {
    dropsLoader,
    Editor,
    uploadProgress,
  },
  props: ['active-ticket'],
  data() {
    return {
      statuses: [
        'new',
        'closed',
        'needs-feedback',
        'assigned',
        'in-progress',
      ],
      ticket: {},
      uuid: 'view-storm-ticket-editor',
      $tinymce: null,
      bucketPath: '',
      commentMessage: '',
      commenttype: 'public',
      tinyLoader: false,
      hideTextEditor: true,
      statusLoading: false,
      selectedStatus: false,
      loading: false,
      loadError: false,
      addComment: false,
      changeStatus: false,
      openUsers: false,
      searchInput: '',
      userLoading: false,
      submitError: false,
      loadApp: false,
      tinyMce: {
        apiKey: process.env.TINY_MCE_API_KEY,
        contentStyle: '.mce-content-body { font-weight:300; }',
        plugins: [
          'wordcount',
          'link',
          'image',
          'lists',
          'codesample',
          'hr',
        ],
        toolbar: 'fontsizeselect | bold italic underline forecolor link | backcolor | image | bullist numlist | hr | codesample | undo redo',
        fontSizes: '10px 11px 12px 13px 14px 16px 18px 24px 36px 48px',
      },
    };
  },
  created() {
    this.hideTextEditor = false;
    this.tinyLoader = true;
    this.getStormUsers();
    this.loadTicket();
  },
  mounted() {
    if (!this.loadError) {
      $(document).ready(this.highlightCode());
    }
  },
  methods: {
    initEditor() {
      this.$tinymce = tinymce;
      this.tinyLoader = false;
    },
    async loadTicket() {
      if (this.activeTicket) {
        this.ticket = this.activeTicket;
      } else {
        await this.getTicket({
          id: this.$router.currentRoute.params.id,
        });
      }
      await this.getTicketUsers();
      this.selectedStatus = this.ticket.status;
    },
    async getTicket({ id }) {
      this.loading = true;
      try {
        const { data } = await this.stormInvoke({
          data: {
            method: 'getStormTicket',
            ticketId: id,
          },
        });
        this.highlightCode();
        this.ticket = data.ticket;
      } catch (e) {
        const message = e.messge || e;
        this.loadError = message;
        this.$log.error(message);
      } finally {
        this.loading = false;
      }
    },
    async openDrzzle() {
      try {
        this.loadApp = true;
        const { data } = await this.stormInvoke({
          data: {
            method: 'getUserData',
            cognito: this.ticket.sub,
            chosenUser: {
              identity_id: this.ticket.account,
            },
          },
        });
        const payload = data.userData;
        this.setCognitoUserAttrs(payload);
        this.$store.dispatch('setCurrentUser', { values: payload, vm: this });
        this.$store.dispatch('setAccount', payload);
        this.$store.dispatch('setUserIdentitiyId', payload._id);
        this.$store.dispatch('setWebsites', { websites: payload.websites });
        this.$store.dispatch('setGlobalValue', {
          item: this.cache,
          key: 'tickets',
          value: false,
        });
        this.$router.push({ path: '/websites' });
      } catch (e) {
        const message = e.message || e.body || e;
        this.$log.error(message);
        this.$store.dispatch('addNotification', {
          type: 'error',
          id: this.guid(),
          message,
        });
      } finally {
        this.loadApp = false;
      }
    },
    setCognitoUserAttrs(user) {
      const attrs = {
        sub: user.sub,
        name: user.name,
        email: user.name,
      };
      if (user.website) {
        attrs.website = user.website;
      }
      if (user.picture) {
        attrs.picture = user.picture;
      }
      if (user.stripeId) {
        attrs.stripeId = user.stripeId;
      }
      if (user.sub_user_owner) {
        attrs.sub_user_owner = user.sub_user_owner;
      }
      this.$store.dispatch('setUserAttributes', user.attrs);
      return this.$store.dispatch('setCurrentUser', { values: attrs, vm: this });
    },
    async saveStatus() {
      this.statusLoading = true;
      const notification = {
        id: this.guid(),
        type: 'success',
        message: 'Ticket status successfully saved!',
      };
      try {
        await this.stormInvoke({
          data: {
            method: 'updateStormTicket',
            ticketId: this.ticket._id,
            updates: [{
              key: 'status',
              value: this.selectedStatus,
            }],
          },
        });
        this.$store.dispatch('setGlobalValue', {
          item: this.ticket,
          key: 'status',
          value: this.selectedStatus,
        });
        this.changeStatus = false;
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        notification.type = 'error';
        notification.message = message;
      } finally {
        this.statusLoading = false;
        this.$store.dispatch('addNotification', notification);
      }
    },
    uploadImage(cb) {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      const self = this;
      input.onchange = async function onFileChange() {
        const file = this.files[0];
        const title = `${Date.now()}-${file.name}`;
        const filePath = `${self.ticket._id}/${path.basename(title)}`;
        const progress = self.$refs.progress.$el;

        if (progress) {
          // move the progress component into the tinyMce image upload modal
          const modalContent = document.querySelectorAll('[id^=dialog-describe_] .tox-dialog__body-content .tox-form')[0];
          modalContent.insertBefore(progress, modalContent.firstChild);
        }

        const upload = await self.uploadFile({
          file: filePath,
          body: file,
          Bucket: process.env.S3_TICKET_ASSETS_BUCKET,
          ACL: 'public-read',
          bucketPath: '',
          copyToOwner: false,
        });

        cb(upload.Location, { title });
      };
      input.click();
    },
    async assignUser(user) {
      try {
        this.stormUsersError = false;
        this.loadingStormUsers = true;
        await this.stormInvoke({
          data: {
            method: 'assignStormTicket',
            assign: {
              from: this.stormUser.sub,
              fromName: this.stormUser.name,
              to: user._id,
            },
            ticketId: this.ticket._id,
          },
        });
        this.$store.dispatch('setGlobalValue', {
          item: this.ticket,
          key: 'assigned',
          value: user._id,
        });
        this.openUsers = false;
      } catch (e) {
        const message = e.message || e;
        this.stormUsersError = message;
        this.$log.error(message);
      } finally {
        this.loadingStormUsers = false;
      }
    },
    async getTicketUsers() {
      this.loadError = false;
      this.userLoading = true;
      try {
        const commentUsers = _.uniqBy(this.ticket.comments, 'author');
        const needed = commentUsers.filter(c => !this.ticketUsers[c.author]);
        if (needed.length > 0) {
          const { data } = await this.stormInvoke({
            data: {
              method: 'getTicketUsers',
              needed,
            },
          });
          const { users } = data;
          users.forEach((user) => {
            this.$store.dispatch('setTicketUser', {
              id: user._id,
              data: user,
            });
          });
        }
        const { sub, name, pic } = this.stormUser;
        if (!this.ticketUsers[sub]) {
          this.$store.dispatch('setTicketUser', {
            id: sub,
            data: { pic, _id: sub, fullName: name },
          });
        }
      } catch (e) {
        const message = e.messge || e;
        this.loadError = message;
        this.$log.error(message);
      } finally {
        this.userLoading = false;
      }
    },
    getAuthor(comment) {
      return this.ticketUsers[comment.author] || {
        pic: DEFAULT_PROFILE_PIC,
        fullName: 'Drzzle Team Member',
      };
    },
    async submitComment() {
      this.submitError = false;
      if (this.commentMessage.replace(/\s/g, '') === '') {
        this.submitError = 'Comment cannot be empty.';
        return;
      }
      this.tinyLoader = true;
      const notification = {
        id: this.guid(),
        type: 'success',
        message: 'Comment added successfully!',
      };
      try {
        const created = moment(moment.utc().format())._i;
        const comment = {
          _id: this.guid(),
          created,
          status: this.commenttype,
          attachments: [],
          author: this.stormUser.sub,
          message: this.commentMessage,
          team: true,
          plainText: this.$tinymce.activeEditor.getContent({ format: 'text' }),
        };
        await this.stormInvoke({
          data: {
            method: 'commentStormTicket',
            ticketId: this.ticket._id,
            comment,
          },
        });
        const ticket = this.ticket;
        this.$store.dispatch('runStateFn', {
          fn() {
            ticket.comments.splice(0, 0, comment);
          },
        });
        this.addComment = false;
        this.commentMessage = '';
        this.commenttype = 'public';
      } catch (e) {
        const message = e.message || e;
        notification.type = 'error';
        notification.message = message;
        this.$log.error(message);
      } finally {
        this.tinyLoader = false;
        this.$store.dispatch('addNotification', notification);
        this.highlightCode();
      }
    },
    getAttr(list, type) {
      const attr = _.find(list, { Name: type });
      return attr ? attr.Value : null;
    },
    highlightCode() {
      this._debounce(() => {
        const commentWrap = document.getElementById('adminUi-ticket-container');
        if (commentWrap) {
          Prism.highlightAllUnder(commentWrap);
        }
      }, 500);
    },
    formatTime(time) {
      return moment.utc(time).local().format('MMM DD, YYYY h:mm a');
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/pages/tickets/view/index.js